  <script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AddCampaignsModal from "@/view/components/campaigns/AddCampaignsModal.vue";
import CampaignsWithSendgrid from "@/view/components/campaigns/CampaignsWithSendgrid.vue";
import CampaignResultTable from "@/view/components/campaigns/CampaignResultTable.vue";
import LocalPerformanceMarketingModal from "@/view/components/campaigns/LocalPerformanceMarketingModal.vue";
import OtherCampaignDialog from "@/view/components/campaigns/OtherCampaignDialog.vue";
import EmailCampaign from "@/view/components/campaigns/EmailCampaign.vue";
import ButtonMenuCampaign from "@/view/components/campaigns/ButtonMenuCampaign.vue";
import { sendCampaign, removeCampaigns, getCampaignSummary} from "@/api/campaigns.js";
import swal from "sweetalert";
import moment from "moment";
import { getLocations, getLocationGroup } from "@/api/locations";
import { money_format } from "@/utils";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";

export default {
  name: "campaigns",
  components: {
    AddCampaignsModal,
    CampaignsWithSendgrid,
    EmailCampaign,
    LocalPerformanceMarketingModal,
    OtherCampaignDialog,
    ButtonMenuCampaign,
    CampaignResultTable,
    DataTableSection
  },
  data() {
    return {
      search: "",
      items: [],
      loading: true,
      snackbar: false,
      text: "Loading campaigns...",
      timeout: 2000,
      item_selected: [],
      btnSend: "SEND",
      btnSendDisabled: false,
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected items?",
      error: false,
      show_other_campaign: false,
      campaign_id: null,
      campaign_type: null,
      show_email_campaign: false,
      show_per_campaign_results: false,
      locations: [],
      lpm: false,
      tableDataParam: {
        getters: 'getCampaigns',
        dispatchFunction: 'getCampaignList',
        headers: [
          {
            text: "Title",
            align: "center",
            sortable: true,
            value: "name"
          },
          { text: "Campaign Type", value: "type", align: "center", width: '140px' },
          { text: "Date Sent", value: "date_sent", align: "center" },
          { text: "Date Created", value: "created", align: "center", width: '100px'},
          { text: "Revenue", value: "revenue", align: "center", width: '100px' }
        ]
      },
      customRenderers: [
      {
          field: "name",
        },
        {
          field: "date_sent",
        },
        {
          field: "revenue",
        },
        {
          field: "created",
        },
        {
          field: "custom_new_customer",
        },
        {
          field: "custom_new_customerVsAve",
        },
        {
          field: "custom_repeat_customer",
        },
        {
          field: "custom_repeat_customerVsAve",
        }
      ],
      location_groups: [],
      hasLocationGroups: false,
      datatableColumn: {
        selected: [
          {
            "text": "New Customers",
            "value": "new_customer"
          }
      ],
        defaultFeaders: [
          {
            text: "Title",
            align: "center",
            sortable: true,
            value: "name"
          },
          { text: "Campaign Type", value: "type", align: "center", width: '140px' },
          { text: "Date Sent", value: "date_sent", align: "center" },
          { text: "Date Created", value: "created", align: "center", width: '100px'},
          { text: "Revenue", value: "revenue", align: "center", width: '100px' }
          // { text: "Action", value: "send", align: "center" }
        ]
      },
      datatableColumnItem:[
          { text: "New Customers", value: "new_customer" },
          { text: "Repeat Customers", value: "repeat_customer"},
      ],
      maxDisplay: 1,
      campaignSummary: {
        average_new_customer_count : 0, 
        average_new_customer_percentage : 0, 
        average_repeat_customer_count : 0,
        average_repeat_customer_percentage: 0
      },
      newlySegmentSendgrid: '0'
    };
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Campaigns" }]);
    this.$store.commit("setLocationVisibile", false);
    this.$store.commit("setHasChanges", false);
    let campaignSummaryResp = await getCampaignSummary()

    this.campaignSummary.average_new_customer_count = campaignSummaryResp.average_new_customer_count
    this.campaignSummary.average_new_customer_percentage = (Math.round(campaignSummaryResp.average_new_customer_percentage * 100) / 100) + '%'
    this.campaignSummary.average_repeat_customer_count = campaignSummaryResp.average_repeat_customer_count
    this.campaignSummary.average_repeat_customer_percentage = (Math.round(campaignSummaryResp.average_repeat_customer_percentage * 100) / 100) + '%'
    this.$nextTick(() => {
      this.adtjustTableFromCheckbx(this.datatableColumn.selected)
    })
    this.locations = await getLocations();
    if (this.locations.length == 0) {
      swal("No locations detected", "Please create atleast one.").then(() => {
        this.$router.push(`/locations`);
      });
    }
    const response_location_groups = await getLocationGroup();
    if (!response_location_groups) {
      swal(
        "",
        "Something went wrong in fetching location groups. Please try again later"
      );
    }
    if (response_location_groups) {
      this.location_groups = response_location_groups;
      
      setTimeout(() => {
        this.hasLocationGroups = response_location_groups && response_location_groups.length > 0 ? true : false;
      }, 2000);
    }
    let queryString = window.location.search
    let urlParams = new URLSearchParams(queryString)
    
    if( urlParams.has('to-sendgrid') ){
      this.newlySegmentSendgrid = urlParams.get('to-sendgrid')
      let componentEvent = this.$refs.acsComponent
      componentEvent.showModal()
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    searchTrigger() {
      return this.search;
    },
    likesAllItems() {
      return this.datatableColumn.selected.length === this.datatableColumnItem.length;
    },
    likesSomeItem() {
      return this.datatableColumn.selected.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    showSendgridModal(){
      
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    searchTrigger(q) {
        let componentEvent = this.$refs.dataTableComponent
        componentEvent.updateSearchField(q)
    },
    "datatableColumn.selected"(selectedAdded){
      this.adtjustTableFromCheckbx(selectedAdded)
    } 
  },
  methods: {
    adtjustTableFromCheckbx(selectedAdded){
      let addedColumn = []
      let newCustomerMetric = [
          { text: "New Customer", value: "custom_new_customer", align: "center", width: '150px' },
          { text: "vs Average", value: "custom_new_customerVsAve", align: "center", width: '150px' },
      ]
      let repeatCustomerMetric =  [
          { text: "Repeat Customer", value: "custom_repeat_customer", align: "center", width: '150px' },
          { text: "vs Average", value: "custom_repeat_customerVsAve", align: "center", width: '150px' },
      ]
      for (let i = 0; i < selectedAdded.length; i++) {
        let metricPaird = selectedAdded[i].value;
        if (metricPaird == 'new_customer'){
          addedColumn.push(newCustomerMetric);
        } else if (metricPaird == 'repeat_customer'){
          addedColumn.push(repeatCustomerMetric);
        }
      }
      this.tableDataParam.headers = [...this.datatableColumn.defaultFeaders] // reset the default header before adding new
      this.tableDataParam.headers  = [...this.tableDataParam.headers , ...addedColumn.flat()] // merging the default and selected row
    },
    customNewCustomer(item){
      let nCustomer = item.new_customers_count
      let ncCustomerCount = item.total_customers_count
      let valueHere = ncCustomerCount > 0 ? (nCustomer / ncCustomerCount) * 100 : 0
      valueHere = Math.round( valueHere * 100)/100
      nCustomer = Math.round(nCustomer).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
      
      return `${nCustomer} (${valueHere}%)`
    },
    vsCustomNewCustomer(item){
      let resp = ''
      let classAtr = ''
      let signAtr = ''
      let customerCount = item.new_customers_count
      let aveNewCustomerCount = this.campaignSummary.average_new_customer_count
      let value1 = customerCount - aveNewCustomerCount
      let value2 = aveNewCustomerCount > 0 ? ((customerCount - aveNewCustomerCount) / aveNewCustomerCount ) * 100 : 0
      if (value1 < 0) {
        classAtr = 'red--text'
      }else if (value1 > 0){
        classAtr = 'green--text'
        signAtr = '+'
      }
      value2 = Math.round( value2 * 100)/100
      value1 = Math.round(value1).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
      
      resp =  `<span class="${classAtr}">${signAtr}${value1} (${signAtr}${value2}%)</span>`
      return resp
    },
    customRepeatCustomer(item){
      let resp = ''
      let customerCount = item.total_customers_count
      let newCustomerCount = item.new_customers_count
      let value1 = customerCount - newCustomerCount
      let value2 =  customerCount > 0 ? (value1 / customerCount) * 100 : 0
      value2 = Math.round( value2 * 100)/100
      value1 = Math.round(value1).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")

      resp =  `<span class="">${value1} (${value2}%)</span>`
      return resp

    },
    vsCustomRepeatCustomer(item){
      let resp = ''
      let classAtr = ''
      let signAtr = ''
      let repeatCustomerCount = item.total_customers_count -item.new_customers_count
      let avgCustomerCount = this.campaignSummary.average_repeat_customer_count
      let value1 = repeatCustomerCount - this.campaignSummary.average_repeat_customer_count
      let value2 = avgCustomerCount > 0 ? ((repeatCustomerCount - avgCustomerCount) / avgCustomerCount) * 100 : 0
      if (value1 < 0) {
        classAtr = 'red--text'
      }else if (value1 > 0){
        classAtr = 'green--text'
        signAtr = '+'
      }
      value2 = Math.round( value2 * 100)/100
      value1 = Math.round(value1).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
      
      resp =  `<span class="${classAtr}">${signAtr}${value1} (${signAtr}${value2}%)</span>`
      return resp

    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.datatableColumn.selected = [];
        } else {
          let data = [];
          // for (let i = 0; i < this.datatableColumnItem.length; i++) {
          //   let item = this.datatableColumnItem[i];
          //   data.push(item.value);
          // }
          this.datatableColumn.selected =  this.datatableColumnItem;
        }
      });
    },
    dateCreated(v) {
      return moment(v).format("lll");
    },
    dateSent(v) {
      if (v.type == "other-campaign") {
        return "-";
      }
      return moment(v.date_sent).format("lll");
    },
    formatMoney(v) {
      return money_format(v);
    },
    async sendCampagn(item) {
      this.btnSendDisabled = true;
      const send = await sendCampaign(item.id);
      if (send) {
        swal("Campaign sent");
      }
      this.btnSendDisabled = false;
    },
    showOtherCampaign() {
      this.show_other_campaign = true;
      this.campaign_id = null;
    },
    removeCampaignItems() {
      if (this.item_selected.length == 0) {
        this.error = true;
        this.dialogMsg = "Please select atleast one item";
      } else {
        this.dialogMsg = "Are you sure you want to delete this selected items?";
        this.error = false;
      }
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    removeItemsConfirm() {
      if (this.item_selected.length > 0) {
        this.item_selected.forEach(val => {
          this.deleteItems(val.id);
        });
        setTimeout(() => {
          this.loading = true;
          this.$store.dispatch("getCampaignList");
        }, 2000);
      }
      this.dialogDelete = false;
      this.item_selected = [];
    },
    async deleteItems(id) {
      await removeCampaigns(id);
    },
    handleOtherCampaignClose() {
      this.show_other_campaign = false;
      this.campaign_id = null;
      this.campaign_type = null;
    },
    handleEmailCampaignClose() {
      this.show_email_campaign = false;
      this.campaign_id = null;
      this.campaign_type = null;
    },
    handleCampaignResultTableClose() {
      this.campaign_id = null;
      this.campaign_type = null;
      this.show_per_campaign_results = false;
    },
    showLpm() {
      this.lpm = true;
    },
    showCampaign(item) {
      // console.log("item", item);
      this.campaign_id = item.id;
      this.campaign_type = item.type;
      
      if( 'campaign_type' in item ){
        if(item['campaign_type'] == "sendgrid" &&
           (item['automation_id'] == null ||
           item['automation_id'] == '') ){
             let componentEvent = this.$refs.acsComponent
              componentEvent.showUpdadeModeModal(item)
             return true
        }
      }
      if (item.type == "email") {
        this.show_email_campaign = true;
      }
      if (item.type == "other-campaign") {
        this.show_other_campaign = true;
      }
    },
    showCampaignResultTable(item) {
      this.campaign_id = null;
      this.campaign_id = item.id;
      this.show_per_campaign_results = true;
    },
    syncSelectedItem(selectedCollection) {
      this.item_selected = selectedCollection
    },
    addClassForSendgrid(data){
      if( 'campaign_type' in data ){
        if(data['campaign_type'] == "sendgrid" &&
           (data['automation_id'] == null ||
           data['automation_id'] == '') ){
             return 'bg-color-yellow'
        }
      }
      return ''
    }
  }
};
</script>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-card flat>
        <v-row class="p-5">
          <v-col cols="5" md="5">
            <button-menu-campaign
              @removeCampaignItems="removeCampaignItems"
              @showOtherCampaign="showOtherCampaign"
              @showLpm="showLpm"
            ></button-menu-campaign>
          </v-col>
          <v-col cols="3" md="3">
            <v-select
              label="Table Metrics"
              v-model="datatableColumn.selected"
              :items="datatableColumnItem"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              return-object
            >
              <template v-slot:prepend-item>
                <v-divider class="mt-2"></v-divider>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="datatableColumn.selected.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template
                v-if="datatableColumn.selected.length > 1"
                v-slot:selection="{ item, index }"
              >
                <span v-if="index === maxDisplay">
                  {{ datatableColumn.selected.length }} selected
                </span>
              </template>
            </v-select>
            </v-col>
            <v-col cols="4" md="4">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <b-icon icon="search"></b-icon>
                  </div>
                </div>
                <b-form-input v-model="search"></b-form-input>
              </div>
            </v-col>
          </v-row>
          <div>
            <span
              class="text-center display-b pb-5 v-card__title text-h5"
            >
              Average Campaign Performance
            </span>
          </div>
          <v-row class="mb-10 align-items-center justify-content-center">
            <v-col md="5">
              <v-card class="mx-auto" max-width="450">
                <v-card-title class="text-center display-b v-card__title">
                  New Customers
                </v-card-title>
                <v-card-text v-if="campaignSummary.average_new_customer_count == 0" class=" text-center display-b text-h3 font-weight-bold">
                  {{Math.round(campaignSummary.average_new_customer_count).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}}
                  <span class="text-h5 font-weight-bold">
                  {{campaignSummary.average_new_customer_percentage}}
                  </span>
                </v-card-text>

                <v-card-text v-if="campaignSummary.average_new_customer_count != 0" class=" text-center display-b text-h3 blue--text font-weight-bold">
                  {{Math.round(campaignSummary.average_new_customer_count).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}}
                  <span class="text-h5 font-weight-bold green--text">
                  {{campaignSummary.average_new_customer_percentage}}
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="5">
              <v-card class="mx-auto" max-width="450">
                  <v-card-title class="text-center display-b v-card__title">
                    Repeat Customers
                  </v-card-title>
                  <v-card-text v-if="campaignSummary.average_repeat_customer_count == 0" class=" text-center display-b text-h3 font-weight-bold">
                      {{Math.round(campaignSummary.average_repeat_customer_count).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}}
                    <span class="text-h5 font-weight-bold">
                      {{campaignSummary.average_repeat_customer_percentage}}
                    </span>
                  </v-card-text>

                  <v-card-text v-if="campaignSummary.average_repeat_customer_count != 0" class=" text-center display-b text-h3 blue--text font-weight-bold">
                      {{Math.round(campaignSummary.average_repeat_customer_count).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}}
                    <span class="text-h5 font-weight-bold green--text">
                      {{campaignSummary.average_repeat_customer_percentage}}
                    </span>
                  </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        <data-table-section
          :tableData="this.tableDataParam"
          :customRenderers="this.customRenderers"
          :isSelectEnabled="true"
          :itemRowClasses="addClassForSendgrid"
          @datatableSelectedItem="syncSelectedItem"
          ref="dataTableComponent"
        >
          <template v-slot:custom_new_customerparams="{ item }">
            {{customNewCustomer(item)}}
          </template>
          <template v-slot:custom_new_customerVsAveparams="{ item }">
             <div v-html="vsCustomNewCustomer(item)" /> 
          </template>
          <template v-slot:custom_repeat_customerparams="{ item }">
            <div v-html="customRepeatCustomer(item)" /> 
          </template>
          <template v-slot:custom_repeat_customerVsAveparams="{ item }">
             <div v-html="vsCustomRepeatCustomer(item)" /> 
          </template>
          <template v-slot:nameparams="{ item }">
            <v-btn text color="primary" @click="showCampaign(item)">
              {{ item.name }}
            </v-btn>
          </template>
          <template v-slot:date_sentparams="{ item }">
            {{ dateSent(item) }}
          </template>
          <template v-slot:revenueparams="{ item }">
            {{ formatMoney(item.revenue) }}
          </template>
          <template v-slot:createdparams="{ item }">
            {{ dateCreated(item.created) }}
          </template>
          <template v-slot:sendparams="{ item }">
            <div class="d-flex">
              <v-btn
                button
                color="success"
                @click="sendCampagn(item)"
                :disabled="btnSendDisabled"
                v-if="item.type == 'email'"
                small
              >
                {{ btnSend }}
              </v-btn>
              <v-btn
                v-if="item.type == 'email'"
                button
                color="primary"
                @click="showCampaignResultTable(item)"
                small
                class="ml-2"
              >
                Result
              </v-btn>
            </div>
          </template>
        </data-table-section>



        <!-- <v-data-table
          v-model="item_selected"
          :headers="headers"
          :items="items"
          show-select
          item-key="id"
          :search="search"
          :hide-default-header="false"
          :loading="loading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.name="{ item }">
            <v-btn text color="primary" @click="showCampaign(item)">
              {{ item.name }}
            </v-btn>
          </template>
          <template v-slot:item.date_sent="{ item }">
            {{ dateSent(item) }}
          </template>
          <template v-slot:item.revenue="{ item }">
            {{ formatMoney(item.revenue) }}
          </template>
          <template v-slot:item.created="{ item }">
            {{ dateCreated(item.created) }}
          </template>
          <template v-slot:item.send="{ item }">
            <div class="d-flex">
              <v-btn
                button
                color="success"
                @click="sendCampagn(item)"
                :disabled="btnSendDisabled"
                v-if="item.type == 'email'"
                small
              >
                {{ btnSend }}
              </v-btn>
              <v-btn
                v-if="item.type == 'email'"
                button
                color="primary"
                @click="showCampaignResultTable(item)"
                small
                class="ml-2"
              >
                Result
              </v-btn>
            </div>
          </template>
        </v-data-table> -->






      </v-card>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog v-model="dialogDelete" max-width="510px">
        <v-card>
          <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete"
              >Cancel</v-btn
            >
            <v-btn
              v-if="!error"
              color="blue darken-1"
              text
              @click="removeItemsConfirm"
              >OK</v-btn
            >

            <v-btn v-if="error" color="blue darken-1" text @click="closeDelete"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <add-campaigns-modal></add-campaigns-modal>
      <campaignsWith-sendgrid
        ref="acsComponent"
      >
      </campaignsWith-sendgrid>
      <local-performance-marketing-modal
        v-if="lpm"
      ></local-performance-marketing-modal>
      <email-campaign
        v-if="show_email_campaign"
        :show="show_email_campaign"
        :locations="locations"
        :campaign_id="campaign_id"
        @close="handleEmailCampaignClose"
      ></email-campaign>
      <other-campaign-dialog
        v-if="show_other_campaign"
        :show="show_other_campaign"
        :locations="locations"
        :location_groups="location_groups"
        :campaign_id="campaign_id"
        @close="handleOtherCampaignClose"
      ></other-campaign-dialog>
      <campaign-result-table
        v-if="show_per_campaign_results"
        :show="show_per_campaign_results"
        :locations="locations"
        :campaign_id="campaign_id"
        @close="handleCampaignResultTableClose"
      ></campaign-result-table>
    </v-main>
  </v-app>
</template>

<style>
.display-b{
  display: block !important;
}
.bg-color-yellow{
  background-color:#ffff0080;
}
</style>